import React from "react";
import OurApi from "./sections/OurApi";

/**
 * Standalone "Platform Overview" page.
 *
 * Reuses the OurApi section (id="platform-overview") that also appears on the
 * homepage, so the layout and design stay identical to the source section.
 * Rendered inside PageLayout, so it gets the site Header + Footer.
 */
const PlatformOverview = () => {
  return <OurApi />;
};

export default PlatformOverview;
